import React from 'react'
import { Link } from 'react-router-dom'
import Icon from './icons'
import { settings } from '../../content/site'

// Ported from the source project's src/components/site/FinalCta.tsx. `primaryCta`/
// `secondaryCta` are <Link>s to /contant (both "Submit a case" and "Request fee schedule"
// - matching Task 4's identical ruling for Hero's CTAs of the same copy: /contant is the
// only route in the app that accepts an enquiry). `callCta` ("Call us") is a real tel:
// link built from settings.contact.phone - the source left it an inert <button> with no
// destination, which would be a dead call-to-action on a live business site.
const FinalCta = ({ section }) => {
    const c = section.content ?? {};
    const primaryCta = c.primaryCta ?? 'Submit a case';
    const secondaryCta = c.secondaryCta ?? 'Request fee schedule';
    const callCta = c.callCta ?? 'Call us';
    const telHref = `tel:${settings.contact.phone.replace(/[^\d+]/g, '')}`;

    return (
        <section className="section">
            <div className="container final-cta">
                <div className="cta-box">
                    <div className="section-eyebrow" style={{ justifyContent: 'center', display: 'flex', marginBottom: 16 }}>
                        {section.eyebrow}
                    </div>
                    <h2>{section.title}</h2>
                    <p>{section.subtitle}</p>
                    <div className="cta-actions">
                        <Link className="btn-lg" to="/contant">{primaryCta}</Link>
                        <Link className="btn-lg-ghost" to="/contant">{secondaryCta}</Link>
                        <a className="btn-call" href={telHref}>
                            <Icon name="phone" />
                            {callCta}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FinalCta;
